var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 6.0006,
    fill: "#37A134"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3396 7.36392H10.442L7.92085 13.5719H9.5474L11.3908 8.77359L13.2478 13.5719H14.8608L12.3396 7.36392Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7134 18.1398H10.6999C9.73751 18.0449 8.82935 17.7602 8.00253 17.3129C6.40309 16.4319 5.14252 14.9544 4.58679 13.0839C4.0446 11.1998 4.30214 9.27509 5.16963 7.67566C5.61693 6.86239 6.22688 6.13044 6.97238 5.53404L6.98594 5.52049C8.08386 4.62589 9.42575 4.01594 10.8896 3.82617H10.9439L11.5538 5.33072C11.5538 5.33072 11.4996 5.33072 11.486 5.33072C10.1984 5.41205 8.99201 5.90002 8.01608 6.68618C8.00253 6.69973 7.98897 6.71329 7.97542 6.71329C7.94831 6.7404 7.9212 6.75395 7.90765 6.78106H7.89409C7.89409 6.79461 7.88054 6.79461 7.88054 6.79461C7.3248 7.25547 6.8775 7.8112 6.53864 8.42116C5.86091 9.66818 5.64404 11.1727 6.07778 12.6366C6.51153 14.1141 7.50101 15.2662 8.74803 15.9439C9.39865 16.3099 10.1306 16.5268 10.8896 16.6081C12.5569 16.7436 14.1156 16.2015 15.3084 15.2255C15.3626 15.1849 15.4169 15.1307 15.4846 15.0764L16.0946 16.581C14.6036 17.7196 12.706 18.3295 10.7134 18.1398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlifIcon);
export default __webpack_public_path__ + "static/media/alif_icon.6287c09cede559e7bf599493854a60d5.svg";
export { ForwardRef as ReactComponent };